const External = () => {
  return (
    <svg width="9.75" height="9.75" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.4 13L0 11.6L9.6 2H1V0H13V12H11V3.4L1.4 13Z" fill="white"/>
    </svg>
  )
}

export default External
